import "123tcs-common/i18n";
import React from "react";
import { createRoot } from "react-dom/client";
import App from "./App";
import { EditorSettingsProvider } from "./contexts/EditorSettings";
import { LanguageProvider } from "./contexts/Language";
import "./index.css";

const root = createRoot(document.getElementById("root"));

// Render
root.render(
  <LanguageProvider>
    <EditorSettingsProvider>
      <App />
    </EditorSettingsProvider>
  </LanguageProvider>,
);
